import { RootState } from 'types/redux';

/**
 * TODO - migrate
 * @param state
 */
export const selectDisableOnIos = (state: RootState) =>
  state.statements.disableOnIos;
